'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormPreview', ['$scope', 'FBResponses', 'DataSets',
        function ($scope, FBResponses, DataSets) {
        $scope.resetForm();
        $scope.previewForm = {};
        $scope.dataSets = [];
        $scope.loading = true;

        $scope.$watch('licenseLoading', function (licenseLoading) {
            if (licenseLoading == false) {
                $scope.parameters = { license_id: $scope.licenseID, default_license_category_id: $scope.license != null ? $scope.license.license_category_id : null };
            }
        })

        DataSets.get($scope.licenseID).then(function (dataSets) {
            $scope.dataSets = dataSets;
        });

        FBResponses.getByID(guid(), $scope.formID).then(function(response) {
            if (response != null) {
                var form = response.form;
                if (form.pages.length > 0) {
                    form.pages[0].tab_active = true;
                }
                $scope.previewForm = form;
            }
            $scope.loading = false;
        });

        $scope.activePage = function () {
            for (var i = 0; i < $scope.form.pages.length; i++) {
                var page = $scope.form.pages[i];
                if (page.tab_active) {
                    return i;
                }
            }
            return 0;
        }
            
    }])
;